// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__PymOg","selects":"Documents_selects__4n0VL"};